import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link
} from "react-router-dom";
import { toast } from 'react-toastify';
import swal from 'sweetalert';
import { observable } from 'mobx';
import { sessionService } from '../../services/SessionService';

interface IndexInventoryProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}
@observer export default class IndexInventory extends React.Component<IndexInventoryProps> {

    @observable private inventories: any;
    @observable private isLoaded = false;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        http.get('/api/inventory/read').then((response) => {
            this.inventories = response.data.response;
            this.isLoaded = true;
        }).catch(() => {
            toast.error("Error cargando inventarios");
        });
    }

    render() {
        if (!this.isLoaded) {
            return null;
        }
        return (
            <Fragment>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header card-header-primary">
                                <h4 className="card-title ">Lista de inventario</h4>
                                <p className="card-category">Lista de inventario registrado</p>
                            </div>
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-sm-10"></div>
                                    <div className="col-sm-2">
                                        {sessionService.canViewSection("Inventario.add") &&
                                            <Link to={`/inventario/nuevo`}>
                                                <button className="btn btn-info btn-lg  pull-right">
                                                    <i className="material-icons">account_circle</i> Nuevo Inventario
                                                <div className="ripple-container"></div>
                                                </button>
                                            </Link>
                                        }
                                    </div>
                                </div>
                                <div className="table-responsive">
                                    <table className="table">
                                        <thead className=" text-primary">
                                            <tr>
                                                <th>ID</th>
                                                <th>Nombre</th>
                                                <th>Creado por</th>
                                                <th>Creado el</th>
                                                <th className="text-right">Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                this.inventories.map((inventory: any, index: any) => {
                                                    return (
                                                        <Fragment key={index}>
                                                            <tr>
                                                                <td>{inventory.id}</td>
                                                                <td>{inventory.name}</td>
                                                                <td>{inventory.created_by_name}</td>
                                                                <td>{inventory.created_date}</td>
                                                                <td className="td-actions text-right">
                                                                    {sessionService.canViewSection("Inventario.view") &&
                                                                        <Link to={`inventario/ver/${inventory.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-info">
                                                                                  <i className="material-icons">visibility</i>
                                                                           </button>
                                                                        </Link>
                                                                   }
                                                                    {sessionService.canViewSection("Inventario.edit") &&
                                                                        <Link to={`inventario/editar/${inventory.id}`}>
                                                                            <button style={{ margin: 5 }} type="button" className="btn btn-success">
                                                                                <i className="material-icons">edit</i>
                                                                            </button>
                                                                        </Link>
                                                                    }
                                                                    {sessionService.canViewSection("Inventario.delete") &&
                                                                        <button onClick={() => this.deleteInventory(inventory.id, index)} style={{ margin: 5 }} type="button" className="btn btn-danger" >
                                                                            <i className="material-icons">close</i>
                                                                        </button>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        </Fragment>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    private deleteInventory = (id: any, index: any): void => {
        swal({
            title: "Confirmar acción",
            text: "¿Estas seguro que quieres borrar el inventario?",
            icon: "warning",
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    const deleteObject = JSON.stringify({
                        id
                    });
                    http.post(`/api/inventory/delete`, deleteObject)
                        .then((response) => {
                            this.inventories.splice(index, 1);
                            toast.success("Inventario borrado correctamente");
                        }).catch((error) => {
                            if (error.includes("foreign")) {
                                toast.error("Error al borrar: Registros ligados a este inventario");
                            } else {
                                toast.error("Error borrando inventario");
                            }
                        })
                }
            });
    }
}